import axiosInstance from "@/boot/axios";
import FormData from "form-data";
import { TestimonialModel } from "../models/TestimonialModel";
import { TestimonialDetailModel } from "../models/TestimonialDetailModel";
import { TestimonialSortEnum } from "../enums/TestimonialSortEnum";
class TestimonialRepository {
    constructor() {
        this.PAGINATION_SIZE = 25;
    }

    async create(testimonial) {
        const response = await axiosInstance.post("/v1/testimonial", testimonial);
        return response.data;
    }

    async uploadVideo(testimonialId, file) {
        const form = new FormData();

        form.append("file", file);

        const config = {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        };
        const response = await axiosInstance.post(`/v1/testimonial/${testimonialId}/video`, form, config);
        return response.data;
    }

    async getPlayToken(testimonial) {
        const response = await axiosInstance.get(`/v1/testimonial/${testimonial.id}/video/key`);
        return response.data;
    }

    async paginatedSearch(page, perPage, status, searchTerm, sort = TestimonialSortEnum.date, order = "desc") {
        const response = await axiosInstance.get("/v1/testimonial", {
            params: {
                status: status.join(","),
                size: perPage ?? this.PAGINATION_SIZE,
                filter: searchTerm,
                sort,
                order,
                page: page,
            },
        });

        response.data.data = response.data.data.map((item) => new TestimonialModel(item));
        return response.data;
    }

    async getDetail(testimonialId) {
        const response = await axiosInstance.get(`/v1/testimonial/${testimonialId}`);

        const detail = new TestimonialDetailModel(response.data);
        return detail;
    }

    async aiSearch(query, page = 1, size, visibility, status, includeArchived) {
        const response = await axiosInstance.get("/v1/testimonial/search", {
            params: {
                page: page ?? 1,
                size: size ?? this.PAGINATION_SIZE,
                visibility,
                status,
                archived: includeArchived,
                query,
            },
        });

        response.data.data = response.data.data.map((item) => new TestimonialModel(item));
        return response.data;
    }

    async update(testimonialId, values) {
        const response = await axiosInstance.put(`/v1/testimonial/${testimonialId}`, values);
        return response.data;
    }

    async approve(testimonialId) {
        const response = await axiosInstance.put(`/v1/testimonial/${testimonialId}/approve`);
        return response.data;
    }

    async hardDelete(testimonialId) {
        const response = await axiosInstance.delete(`/v1/testimonial/${testimonialId}`);
        return response.data;
    }

    async googleDriveBulkUpload(payload) {
        const response = await axiosInstance.post(`/v1/testimonial/bulk-upload-drive`, payload);
        return response.data;
    }

    async googleDriveBulkUploadStatus(payload) {
        const response = await axiosInstance.post(`/v1/testimonial/bulk-upload-drive/status`, payload);
        return response.data;
    }
}

export default new TestimonialRepository();
